<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';

defineProps<{
  title: string;
  text: string;
}>();
</script>

<template>
  <ContentContainer>
    <ContentColumn>
      <div class="title subhead-secondary">
        {{ title }}
      </div>
      <div class="note">
        <div v-html="text" />
      </div>
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
.title {
  color: var(--colour-black);
}
.note {
  margin: var(--spacing-ms) 0;
}
</style>
